import { SessionStorage } from '@hotjar/insights-common/lib/storage-factory';

// Since we need to process this event after we have already created the user,
// store the plan in sessionStorage so we can use it when the user has been logged in.
export const onTrackLogin = (): void => {
  SessionStorage.set('trackLogin', true);
};
